import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

const FreightSnapMark = ({size = 20}: {size?: number}) => (
    <img
        src={toAbsoluteUrl('/media/logos/freightsnap-icon.png')}
        alt="FreightSnap"
        width={size}
        height={size}
        style={{display: 'block', objectFit: 'contain'}}
    />
)

export default FreightSnapMark
